import React from 'react';
import { motion } from 'framer-motion';
import '../styles/MenuToggle.css';

const Path = (props) => (
  <motion.path
    fill="transparent"
    strokeWidth="2.5"
    stroke="#00FFFF"
    strokeLinecap="round"
    strokeLinejoin="round"
    filter="drop-shadow(0 0 3px rgba(0, 255, 255, 0.4))"
    {...props}
  />
);

const MenuToggle = ({ toggle, isOpen }) => {
  // Handle keyboard interaction
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggle();
    }
  };

  return (
    <motion.button 
      className="menu-toggle" 
      onClick={toggle} 
      onKeyDown={handleKeyDown}
      aria-label={isOpen ? "Close menu" : "Open menu"}
      aria-expanded={isOpen}
      aria-controls="mobile-navigation"
      type="button"
      whileHover={{ 
        scale: 1.1,
        backgroundColor: "rgba(0, 255, 255, 0.2)",
        boxShadow: "0 0 20px rgba(0, 255, 255, 0.4)"
      }}
      whileTap={{ scale: 0.9 }}
      animate={{
        backgroundColor: isOpen ? "rgba(0, 255, 255, 0.25)" : "rgba(0, 255, 255, 0.08)",
        boxShadow: isOpen ? "0 0 25px rgba(0, 255, 255, 0.5)" : "0 0 5px rgba(0, 255, 255, 0.1)",
        borderColor: isOpen ? "rgba(0, 255, 255, 0.4)" : "rgba(0, 255, 255, 0.2)"
      }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
    >
      <motion.svg 
        width="100%" 
        height="100%" 
        viewBox="0 0 23 23"
        animate={{ rotate: isOpen ? 180 : 0 }}
        transition={{ duration: 0.4, ease: "easeInOut" }}
        aria-hidden="true"
      >
        <Path
          variants={{
            closed: { d: "M 2 2.5 L 20 2.5" },
            open: { d: "M 3 16.5 L 17 2.5" }
          }}
          animate={isOpen ? "open" : "closed"}
          transition={{ duration: 0.3, ease: "easeInOut" }}
        />
        <Path
          d="M 2 9.423 L 20 9.423"
          variants={{
            closed: { opacity: 1, rotate: 0 },
            open: { opacity: 0, rotate: 180 }
          }}
          transition={{ duration: 0.2, ease: "easeInOut" }}
          animate={isOpen ? "open" : "closed"}
        />
        <Path
          variants={{
            closed: { d: "M 2 16.346 L 20 16.346" },
            open: { d: "M 3 2.5 L 17 16.346" }
          }}
          animate={isOpen ? "open" : "closed"}
          transition={{ duration: 0.3, ease: "easeInOut" }}
        />
      </motion.svg>
    </motion.button>
  );
};

export default MenuToggle;